import { createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from '../../store/store';
import { requireGroupId, extractError } from '../../store/thunkHelpers';
import { createCrudThunks } from '../../store/createCrudThunks';
import {
  rapidContactApi,
  type RapidContactImportResult,
  type RapidContactListParams,
} from './rapidContactApi';
import type { RapidContact } from './rapidContactMappers';
import type {
  RapidContactCreatePayload,
  RapidContactUpdatePayload,
} from './rapidContactTypes';

const thunks = createCrudThunks<
  RapidContact,
  RapidContactCreatePayload,
  RapidContactUpdatePayload,
  RapidContactListParams
>('rapidContacts', rapidContactApi);

export const rapidContactThunks = thunks;
export const {
  fetchAll: fetchRapidContacts,
  fetchOne: fetchRapidContact,
  create: createRapidContact,
  update: updateRapidContact,
  remove: deleteRapidContact,
} = thunks;

/**
 * Import massivo (TS-100) dei contatti fiera non importati del sito corrente.
 * Ritorna l'esito (importati + falliti col motivo, TS-137); non muta lo slice (il
 * chiamante rifetcha la lista, da cui gli importati spariscono perché ora `imported=true`,
 * mentre i falliti restano).
 */
export const importRapidContacts = createAsyncThunk<
  RapidContactImportResult,
  string,
  { state: RootState; rejectValue: string }
>('rapidContacts/import', async (callStartDate, { getState, rejectWithValue }) => {
  try {
    return await rapidContactApi.importAll(requireGroupId(getState), callStartDate);
  } catch (err: unknown) {
    return rejectWithValue(extractError(err));
  }
});
